export function sidebarEvents() {
	const sidebar = document.querySelector(".ilawyer-sidebar .widget");
	if (!sidebar) return;
	async function loadSidebar() {
		try {
			const { initSidebar } = await import("./sidebar.js");
			initSidebar();
		} catch (err) {
			console.error("Failed to load sidebar module:", err);
		}
	}
	loadSidebar();
}
